import formatTime from './formatTime';
import { parseISOLocal } from './date';

export default (dayString, timeString) =>
  formatTime(
    parseISOLocal(
      `${dayString}T${timeString.substr(0, 2)}:${timeString.substr(2, 2)}:00`
    )
  );
